import { z } from "zod";
import type {
    StripePaymentCapturable} from "./stripe-payment-capturable";
import {
    stripePaymentCapturableZodSchema,
} from "./stripe-payment-capturable";
import type {
    StripePaymentFulfilled} from "./stripe-payment-fulfilled";
import {
    stripePaymentFulfilledZodSchema,
} from "./stripe-payment-fulfilled";
import type {
    StripePaymentPending} from "./stripe-payment-pending";
import {
    stripePaymentPendingZodSchema,
} from "./stripe-payment-pending";
import type {
    StripePaymentRefunded} from "./stripe-payment-refunded";
import {
    stripePaymentRefundedZodSchema,
} from "./stripe-payment-refunded";

type StripePayment<ProviderData = unknown> =
    | StripePaymentPending
    | StripePaymentCapturable<ProviderData>
    | StripePaymentRefunded<ProviderData>
    | StripePaymentFulfilled<ProviderData>;

const stripePaymentZodSchema = z.union([
    stripePaymentPendingZodSchema,
    stripePaymentCapturableZodSchema,
    stripePaymentRefundedZodSchema,
    stripePaymentFulfilledZodSchema,
]);

export { stripePaymentZodSchema };
export type { StripePayment };
